<template>
  <!-- サービス終了 -->
  <div v-if="serviceTermination" id="setting-other-default-layout">
    <div id="setting-other-component" :class="componentClassName">
      <a-page-heading :id="idName[1]">リリースバージョン</a-page-heading>
      <m-section>
        <m-action-card :id="idName2[1]" title="バージョン" :header-border="true" :narrow-body="true">
          <a-text v-if="version" id="version-text">{{ version }}</a-text>
        </m-action-card>
      </m-section>
    </div>
  </div>
  <!-- サービス継続中 -->
  <div v-else id="setting-other-default-layout">
    <div id="setting-other-component" :class="componentClassName">
      <a-page-heading :id="idName[1]">リリースバージョン</a-page-heading>
      <m-section>
        <m-action-card :id="idName2[1]" title="バージョン" :header-border="true" :narrow-body="true">
          <a-text v-if="version" id="version-text">{{ version }}</a-text>
        </m-action-card>
      </m-section>

      <a-page-heading :id="idName[2]">その他の設定</a-page-heading>
      <m-section>
        <m-action-card :id="idName2[2]" title="その他の設定" :header-border="true" :narrow-body="true">
          <form ref="form" class="t-setting-other__form" @submit.prevent="handleFormSubmit">
            <div class="t-setting-other__fields">
              <m-form-input v-if="voiceDisplayFlag" id="setting-speaker" label="声色">
                <a-select-field
                  id="-speaker"
                  v-model="setting.speaker"
                  :options="speakerList"
                  :disabled="voiceDisableFlag"
                />
                <a-button
                  v-show="isVoicePlaying"
                  id="stop-audio-button"
                  :disabled="voiceDisableFlag"
                  :inline="true"
                  variant="fill"
                  color="primary"
                  size="medium"
                  icon="audio-pause"
                  @click="stopAudio()"
                />
                <a-button
                  v-show="!isVoicePlaying"
                  id="play-audio-button"
                  :disabled="voiceDisableFlag"
                  :inline="true"
                  variant="fill"
                  color="primary"
                  size="medium"
                  icon="audio-play"
                  @click="playAudio()"
                />
              </m-form-input>
              <div v-if="voiceDisplayFlag" class="boxContainer">
                <div class="left">
                  <p><br />声調パラメータ</p>
                </div>
                <div v-show="!voiceDisableFlag" id="reset-button" class="resetButton" @click="speechReset()">
                  リセット
                </div>
              </div>
              <div v-if="voiceDisplayFlag">
                <div>
                  <m-form-input label="話速">
                    {{ setting.speechRate }}
                  </m-form-input>
                </div>
                <input
                  id="setting-speech-rate-input"
                  v-model.number="setting.speechRate"
                  :disabled="voiceDisableFlag"
                  type="range"
                  min="0.50"
                  max="2.00"
                  step="0.01"
                  class="m-form-input-voice-slider"
                />
                <div>
                  <m-form-input label="音量">
                    {{ setting.powerRate }}
                  </m-form-input>
                </div>
                <input
                  id="setting-power-rate-input"
                  v-model.number="setting.powerRate"
                  :disabled="voiceDisableFlag"
                  type="range"
                  min="0.1"
                  max="5.00"
                  step="0.01"
                  class="m-form-input-voice-slider"
                />
                <div>
                  <m-form-input label="高さ">
                    {{ setting.pitch }}
                  </m-form-input>
                </div>
                <input
                  id="setting-power-pitch-input"
                  v-model.number="setting.pitch"
                  type="range"
                  min="1"
                  max="20"
                  step="1"
                  :disabled="voiceDisableFlag"
                  class="m-form-input-voice-slider"
                />
                <div>
                  <m-form-input label="抑揚">
                    {{ setting.intonation }}
                  </m-form-input>
                </div>
                <input
                  id="setting-power-intonation-input"
                  v-model.number="setting.intonation"
                  :disabled="voiceDisableFlag"
                  type="range"
                  min="1"
                  max="20"
                  step="1"
                  class="m-form-input-voice-slider"
                />
              </div>
              <div v-if="!trialCompany">
                <m-form-input label="COTOHA Voice DX BasicのカスタマーコントロールのURL">
                  <a id="link1" :href="voiceDxCustomerControlUrl" target="blank">
                    {{ voiceDxCustomerControlUrl }}
                  </a>
                </m-form-input>
                <a-text>※COTOHA Call Center のIDとパスワードでログインできます。</a-text>
              </div>
            </div>
            <m-form-action-buttons v-if="voiceDisplayFlag">
              <a-button
                id="save-button-others-setting"
                variant="block"
                color="primary"
                :disabled="voiceDisableFlag || trialCompany"
                @click="handleSaveClick"
              >
                保存
              </a-button>
            </m-form-action-buttons>
          </form>
        </m-action-card>
      </m-section>
      <m-section>
        <m-action-card
          v-if="notifyAuthFlag"
          :id="idName2[3]"
          title="お知らせの設定"
          :header-border="true"
          :narrow-body="true"
        >
          <div
            class="m-user-invitation-list__button"
            style="border: none; justify-content: right; padding-bottom: 30px; padding-top: 0"
          >
            <a-button
              :id="'addItemBtn'"
              variant="fill"
              color="primary"
              :disabled="!addItem"
              size="small"
              label="追加"
              icon="plus"
              @click="handleAddItem"
            />
          </div>

          <div style="height: 100%; max-height: 610px; overflow: auto; padding: 15px; width: 100%">
            <template v-for="index in 10" :key="index">
              <div :id="'block_notice' + index" class="m-form-input" style="display: none; margin-bottom: 30px">
                <div class="m-user-invitation-item__header" style="margin-bottom: 0">
                  <div class="m-user-invitation-item__header-title">お知らせ{{ index }}</div>
                  <div class="m-user-invitation-item__header-action">
                    <a-switch
                      :id="'importantFlag-' + index"
                      v-model="formData['importantFlag' + index]"
                      label="重要タグ"
                    />
                  </div>
                </div>
                <m-form-input :label="'設定するテキスト'">
                  <a-text-field
                    :id="'text' + index"
                    v-model="formData['text' + index]"
                    type="text"
                    placeholder=""
                    maxlength="200"
                  />
                </m-form-input>

                <m-form-input :label="'URLリンク'">
                  <a-text-field
                    :id="'url' + index"
                    v-model="formData['url' + index]"
                    type="text"
                    placeholder=""
                    maxlength="200"
                  />
                </m-form-input>

                <div class="m-user-invitation-list__button" style="justify-content: right; padding-top: 20px">
                  <a-button
                    :id="'delItemBtn' + (index + 1)"
                    variant="fill"
                    color="primary"
                    size="small"
                    label="削除"
                    @click="handleDelItem(index)"
                  />
                </div>
              </div>
            </template>
          </div>
          <form ref="form" class="t-setting-other__form">
            <div class="t-setting-other__fields">
              <m-form-action-buttons>
                <a-button id="back-button" variant="block" color="primary" @click="handleResetNotifyMessageTextClick">
                  元の状態に戻す
                </a-button>
                <a-button
                  id="save-button-notify-setting"
                  variant="block"
                  color="primary"
                  @click="handleSaveNotifyMessageTextClick"
                >
                  保存
                </a-button>
              </m-form-action-buttons>
            </div>
          </form>
        </m-action-card>
      </m-section>
      <m-section>
        <m-action-card :id="idName2[7]" title="ログイン時の応答可否設定" :header-border="true" :narrow-body="true">
          <a-text>すべてのユーザーのログイン直後のステータスを応答可能にする。</a-text>
          <br />
          <m-form-input>
            <a-switch
              id="responseSettingToggle"
              v-model="afterLoginStatus"
              label=""
              :disabled="!canEditResponseSetting"
            />
          </m-form-input>
          <m-form-action-buttons>
            <a-button
              id="save-button-response-setting"
              variant="block"
              color="primary"
              :disabled="!canEditResponseSetting"
              @click="handleSaveResponseSetting"
            >
              保存
            </a-button>
          </m-form-action-buttons>
        </m-action-card>
      </m-section>
      <m-section>
        <m-action-card
          :id="idName2[8]"
          title="通話メモのオペレータ名自動入力設定"
          :header-border="true"
          :narrow-body="true"
        >
          <a-text>通話メモのオペレータ名を自動入力する。</a-text>
          <br />
          <m-form-input>
            <a-switch
              id="autoInputMemoOperatorNameSettingToggle"
              v-model="autoInputMemoOperatorName"
              label=""
              :disabled="!canEditAutoInputMemoOperatorNameSetting"
            />
          </m-form-input>
          <m-form-action-buttons>
            <a-button
              id="save-button-auto-input-memo-operator-setting"
              variant="block"
              color="primary"
              :disabled="!canEditAutoInputMemoOperatorNameSetting"
              @click="handleSaveAutoInputMemoOperatorNameSetting"
            >
              保存
            </a-button>
          </m-form-action-buttons>
        </m-action-card>
      </m-section>
    </div>
  </div>
  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="settingOther_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="close-modal-button"
          variant="block"
          color="primary"
          label="OK"
          size="small"
          @click="handleCloseModal"
        />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="settingOther_helpModal"
      v-model:visible="helpDialogVisible"
      class="o-modal-help-dialog"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      @close="handleCloseHelpDialog"
    >
      <template #title>{{ currentHelpMessageTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
          <span v-html="currentHelpMessageText" />
          <!-- eslint-enable -->
      </a-text>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import OModal from '@/components/organisms/modal';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { SPEAKER_LIST, SAMPLE_WAV_LIST } from '@/libs/constants';

import { customValidate } from '@/common/customValidate.js'; // #2537
import { POINT } from '@/libs/constants';

import { utils } from '@/common/utils.js';
import { cloneDeep } from 'lodash';

export default {
  name: 't-setting-other',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    OModal,
  },
  mixins: [customRequest, customValidate], // #2537
  props: {
    class: {
      type: String,
      default: '',
    },
    // # 2537
    companyID: {
      type: String,
      default: '',
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      setting: {
        speakerID: 'female2',
        speechRate: '1',
        powerRate: '1',
        pitch: '12',
        intonation: '10',
      },
      speakerList: SPEAKER_LIST ? SPEAKER_LIST : [{ label: '日本語 | 女性 | 大人 | 02', value: 'female2' }],
      sampleWAVLinkList: SAMPLE_WAV_LIST
        ? SAMPLE_WAV_LIST
        : { female2: 'https://storage.googleapis.com/cotoha-sample-voices/ja_JP-F-S0008-T001-E01-SR0_female2.wav' },
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,

      videoObj: {
        playing: false,
      },
      audio: null,
      version: '',
      voiceDxCustomerControlUrl: '',
      // #2537
      authInfo: this.$store.state.user.authInfo,
      notifyAuthFlag: false,
      voiceDisableFlag: false,
      voiceDisplayFlag: true, // #2426
      isVoicePlaying: false,
      helpDialogVisible: false,
      currentHelpType: '',
      dictionaryTitleHelpMessage: '辞書とは',
      dictionaryBodyHelpMessage:
        '音声を認識してテキスト化する際、認識精度を向上させるために、優先的に変換候補となる単語や文章をヒントとして登録できます。<br>業界用語や専門用語、商品名など一般的ではない単語の認識率を高めたい場合などに便利です。<br>ヒントは最大50個、1個当たり最大20文字まで入力可能です。<br>各ヒントは、1から10のブースト値が設定でき、数値が大きいほど同音の語句における変換優先度が高くなります。',
      idName: [],
      idName2: [],
      //#3715
      trialCompany: false,
      addCompanyRuler: true,
      addItem: true,
      viewNotice: 1,
      formData: {},
      noticeList: {},
      afterLoginStatus: false,
      autoInputMemoOperatorName: false,
      addCount: 0,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-other');
      return `${baseClassName} ${this.class}`.trim();
    },
    currentHelpMessageTitle() {
      if (this.currentHelpType === 'dictionary') {
        return this.dictionaryTitleHelpMessage;
      }
      return '';
    },
    currentHelpMessageText() {
      if (this.currentHelpType === 'dictionary') {
        return this.dictionaryBodyHelpMessage;
      }
      return '';
    },
    canEditResponseSetting() {
      return this.authInfo === 'supervisor' || this.authInfo === 'manager';
    },
    canEditAutoInputMemoOperatorNameSetting() {
      return this.authInfo === 'supervisor' || this.authInfo === 'manager';
    },
    serviceTermination() {
      return this.$store.state.user.serviceTermination;
    },
  },
  async created() {
    for (let i = 1; i <= 3; i++) {
      this.idName[i] = 'h1-settingother' + i;
    }
    for (let i = 1; i <= 8; i++) {
      this.idName2[i] = 'h4-settingother' + i;
    }

    // For Trial
    if (utils.chkTrialCompanyID(this.companyID)) {
      this.trialCompany = true;
    }
    //Default audio
    this.audio = new Audio(this.sampleWAVLinkList[this.setting.speaker]);
    const self = this;
    this.audio.onended = function () {
      self.videoObj.playing = false;
    };
    await this.handlerFetchSettingOther();
    // #2724
    if (
      (this.authInfo === 'manager' || this.authInfo === 'supervisor' || this.authInfo === 'operator') &&
      this.companyID === POINT
    ) {
      this.notifyAuthFlag = true;
      // #2537
      await this.handlerFetchNotifyMessageText();
    }
    // #2588
    if ((this.authInfo === 'operator' || this.authInfo === 'soOperator') && this.companyID !== POINT) {
      this.voiceDisableFlag = true;
    }
    // #2426
    if (this.authInfo === 'soOperator' && this.companyID === POINT) {
      this.voiceDisplayFlag = false;
    }
  },
  mounted() {
    if (this.trialCompany) {
      this.showInfoModal(messageContent.notifyTrialUserCanNotSaveOther());
    }
  },
  methods: {
    handlerFetchSettingOther: async function () {
      const self = this;
      await this.postRequest('/settingother')
        .then(data => {
          if (data.status === 'success') {
            if (data.data) {
              self.setting.speaker = data.data.speakerID ? data.data.speakerID : 'female2';
              self.version = data.data.version ? data.data.version : '';
              self.voiceDxCustomerControlUrl = data.data.voiceDxCustomerControlUrl
                ? data.data.voiceDxCustomerControlUrl
                : '';
              self.setting.speechRate = data.data.voiceTuningInfo.speechRate
                ? data.data.voiceTuningInfo.speechRate
                : '1';
              self.setting.powerRate = data.data.voiceTuningInfo.powerRate ? data.data.voiceTuningInfo.powerRate : '1';
              self.setting.pitch = data.data.voiceTuningInfo.pitch ? data.data.voiceTuningInfo.pitch : '12';
              self.setting.intonation = data.data.voiceTuningInfo.intonation
                ? data.data.voiceTuningInfo.intonation
                : '10';
              self.afterLoginStatus = data.data.afterLoginStatus;
              self.autoInputMemoOperatorName = data.data.autoInputMemoOperatorName;
            } else {
              self.setting.speaker = 'female2';
              self.setting.speechRate = '1';
              self.setting.powerRate = '1';
              self.setting.pitch = '12';
              self.setting.intonation = '10';
            }
          } else {
            self.showErrorModal(messageContent.requireTry('設定の取得'));
          }
        })
        .catch(error => {
          self.showErrorModal(messageContent.requireTry('設定の取得'));
        });
    },
    handleSaveClick() {
      this.voiceDisableFlag = true;
      const scenarioData = {
        speakerID: this.setting.speaker,
        intonation: this.setting.intonation,
        pitch: this.setting.pitch,
        powerRate: this.setting.powerRate,
        speechRate: this.setting.speechRate,
      };
      const self = this;
      this.setLoading(true);
      this.postRequest('/settingother/save', { data: scenarioData })
        .then(data => {
          if (data.status === 'success') {
            self.showInfoModal('設定を変更しました。');
          } else {
            self.showErrorModal(messageContent.requireTry('保存'));
          }
          this.voiceDisableFlag = false;
          self.setLoading(false);
        })
        .catch(error => {
          self.showErrorModal(messageContent.requireTry('保存'));
          this.voiceDisableFlag = false;
          self.setLoading(false);
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
    playAudio() {
      const scenarioData = {
        speaker: this.setting.speaker,
        intonation: this.setting.intonation,
        pitch: this.setting.pitch,
        powerRate: this.setting.powerRate,
        speechRate: this.setting.speechRate,
      };
      const self = this;
      this.isVoicePlaying = true;
      if (this.audio && this.videoObj.playing === true) {
        this.audio.close();
      }
      this.postRequest('/settingother/testvoice', { data: scenarioData })
        .then(async data => {
          if (data.status === 'success' && data.data.voiceBufferData) {
            self.audio = null;
            self.audio = new AudioContext();
            const arr = Uint8Array.from(data.data.voiceBufferData.data);
            const audio = await self.audio.decodeAudioData(arr.buffer);
            const source = self.audio.createBufferSource();
            source.buffer = audio;
            source.connect(self.audio.destination);
            source.start(0);
            source.onended = function () {
              self.isVoicePlaying = false;
            };
          } else {
            this.isVoicePlaying = false;
            self.showErrorModal(messageContent.requireTry('再生'));
          }
        })
        .catch(error => {
          this.isVoicePlaying = false;
          self.showErrorModal(messageContent.requireTry('再生'));
        });
    },
    stopAudio() {
      if (this.audio && this.isVoicePlaying === true) {
        const self = this;
        this.audio.close().then(function () {
          self.isVoicePlaying = false;
        });
      }
    },
    speechReset: function () {
      this.setting.speechRate = '1';
      this.setting.powerRate = '1';
      this.setting.pitch = '12';
      this.setting.intonation = '10';
    },
    // #2537
    handlerFetchNotifyMessageText: async function () {
      if (this.serviceTermination) return;
      await this.postRequest('/notice/getNotifyMessageList')
        .then(data => {
          if (data.status === 'success') {
            this.noticeList = data.data;

            let i;
            for (i = 0; i < this.noticeList.length; i++) {
              if (this.noticeList[i].text === '') break;
              this.formData['id' + (i + 1)] = this.noticeList[i].id;
              this.formData['text' + (i + 1)] = this.noticeList[i].text;
              this.formData['url' + (i + 1)] = this.noticeList[i].url.replaceAll('%%amp%%', '&');
              this.formData['importantFlag' + (i + 1)] = this.noticeList[i].importantFlag;
              this.formData['updateDate' + (i + 1)] = this.noticeList[i].updateDate;
              this.formData['timestamp' + (i + 1)] = this.noticeList[i].timestamp;
              document.getElementById('block_notice' + (i + 1)).style.display = 'block';
            }
            this.viewNotice = i;
          } else {
            this.showErrorModal(messageContent.requireTry('お知らせの設定取得'));
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('お知らせの設定取得'));
        });
    },
    handleSaveNotifyMessageTextClick() {
      const data = cloneDeep(this.formData);

      // 特殊記号チェック
      for (const key in data) {
        if (key.indexOf('url') !== -1) {
          data[key] = (data[key] + '').replaceAll('&', '%%amp%%');
        }

        if (this.hasSpecialCharacterInObject({ keyWord: data[key] })) {
          let col = key.replace('text', '設定するテキスト');
          col = col.replace('url', 'URLリンク');
          this.showErrorModal(messageContent.requireNotSpecialCharacter(col));
          return;
        }
      }
      this.postRequest('/settingother/setNotifyMessageText', { data: data })
        .then(data => {
          if (data.status === 'success') {
            this.showInfoModal(messageContent.notificationSettingUpdated);
            this.handleResetNotifyMessageTextClick();
          } else {
            if (data.errors !== '') {
              const errMsg = data.errors.map(e => e.msg).join('<br />');
              this.showErrorModal(errMsg);
            } else {
              this.showErrorModal(messageContent.requireTry('お知らせの保存'));
            }
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('お知らせの保存'));
        });
    },
    async handleResetNotifyMessageTextClick() {
      this.addCount = 0;
      this.addItem = true;

      this.formData = {};
      for (let i = 1; i <= 10; i++) {
        document.getElementById('block_notice' + i).style.display = 'none';
      }
      await this.handlerFetchNotifyMessageText();
    },
    handleCloseHelpDialog() {
      this.helpDialogVisible = false;
      this.currentHelpType = '';
    },
    handleAddItem() {
      if (this.viewNotice === 10) {
        this.addCount++;
        if (this.addCount >= 10) {
          this.addItem = false;
        }
      }

      for (let i = this.viewNotice; i > 0; i--) {
        this.formData['id' + (i + 1)] = this.formData['id' + i];
        this.formData['text' + (i + 1)] = this.formData['text' + i];
        this.formData['url' + (i + 1)] = this.formData['url' + i];
        this.formData['importantFlag' + (i + 1)] = this.formData['importantFlag' + i];
        this.formData['updateDate' + (i + 1)] = this.formData['updateDate' + i];
        this.formData['timestamp' + (i + 1)] = this.formData['timestamp' + i];
      }
      this.formData['id1'] = '';
      this.formData['text1'] = '';
      this.formData['url1'] = '';
      this.formData['importantFlag1'] = false;
      this.formData['updateDate1'] = '';
      this.formData['timestamp1'] = '';
      if (this.viewNotice < 10) {
        this.viewNotice = this.viewNotice + 1;
      }
      document.getElementById('block_notice' + this.viewNotice).style.display = 'block';
    },
    handleDelItem(index) {
      this.addCount = 0;
      this.addItem = true;

      for (let i = index; i <= 10; i++) {
        this.formData['id' + i] = this.formData['id' + (i + 1)];
        this.formData['text' + i] = this.formData['text' + (i + 1)];
        this.formData['url' + i] = this.formData['url' + (i + 1)];
        this.formData['importantFlag' + i] = this.formData['importantFlag' + (i + 1)];
        this.formData['updateDate' + i] = this.formData['updateDate' + (i + 1)];
        this.formData['timestamp' + i] = this.formData['timestamp' + (i + 1)];
      }
      document.getElementById('block_notice' + this.viewNotice).style.display = 'none';
      this.viewNotice = this.viewNotice - 1;
    },
    handleSaveResponseSetting() {
      this.postRequest('/settingother/saveResponseSetting', { afterLoginStatus: !!this.afterLoginStatus })
        .then(data => {
          if (data.status === 'success') {
            this.showInfoModal(messageContent.responseAvailabilitySettingUpdated);
          } else {
            throw new Error('Saving error.');
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('ログイン時の応答可否設定'));
        });
    },
    handleSaveAutoInputMemoOperatorNameSetting() {
      this.postRequest('/settingother/saveAutoInputMemoOperatorNameSetting', {
        autoInputMemoOperatorName: !!this.autoInputMemoOperatorName,
      })
        .then(data => {
          if (data.status === 'success') {
            this.showInfoModal(messageContent.autoInputMemmoOperatorNameSettingUpdated);
          } else {
            throw new Error('Saving error.');
          }
        })
        .catch(error => {
          this.showErrorModal(messageContent.requireTry('通話メモのオペレータ名自動入力設定'));
        });
    },
  },
};
</script>
